import {DataTableColumn} from "mantine-datatable";
import {NavLink} from "react-router-dom";
import {PipelineTemplate} from "../types.ts";
import {I18n} from "@aws-amplify/core";
import {formatTimestamp} from "../../../../utils/TableTimestamps.tsx";


export const usePipelineTemplatesTableColumns = () => {

    const columns: DataTableColumn<PipelineTemplate>[] = [
        {
            accessor: 'name',
            title: I18n.get('Name'),
            width: '1fr',
            render: (item: PipelineTemplate) => <NavLink to={`/pipeline-templates/${item.id}`}>{item.name}</NavLink>,
        },
        {
            accessor: 'description',
            title: I18n.get('Description'),
            width: '1fr',
            render: (item: PipelineTemplate) => item.description,
        },
        {
            accessor: 'pipelineType',
            title: I18n.get('Pipeline Type'),
            width: '1fr',
            render: (item: PipelineTemplate) => item.pipelineType,
        },
        {
            accessor: 'stages',
            title: I18n.get('Stages'),
            width: '0.5fr',
            render: (item: PipelineTemplate) => item.stages?.length || 0,
        },
        {
            accessor: 'createdByUsername',
            title: I18n.get('Created By'),
            width: '1fr',
            render: (item: PipelineTemplate) => item.createdByUsername,
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
            width: '1fr',
            render: (item: PipelineTemplate) => formatTimestamp(item.created as string),
        },
    ];

    return {
        columns,
    };
};
